// TODO: Agregar como una instancia o un plugin o algo de Vue en vez de esto
import Vue from 'vue'
const EventBus = new Vue()
export default EventBus



// WEBPACK FOOTER //
// ./src/helpers/event-bus.js